<template>
  <q-layout view="lHh Lpr lFf">
    <Header />
    <q-page-container>
      <q-page padding>
        <div class="row q-pt-lg text-grey-9">
          <div class="col"></div>
          <div class="col-5" style="max-width: 600px">
            <span class="text-h5">Mot de passe oublié</span>
            <q-separator class="q-mt-sm q-mb-lg"/>
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
              <q-form
                @submit.prevent="handleSubmit(onSubmit)"
                class="q-pt-sm"
              >
                <p>
                  Saisissez votre email de connexion, vous recevrez un mail avec un lien pour 
                  réinitialiser votre mot de passe.
                </p>
                <ValidationProvider
                  name="email"
                  ref="email"
                  mode="passive"
                  rules="required|email"
                  v-slot="{ errors, invalid, validated }"
                >
                  <q-input
                    v-model="email"
                    type="email"
                    label="Email"
                    color="grey-9"
                    clearable
                    filled
                    :error="invalid && validated"
                    :error-message="errors[0]"
                    class="q-mb-md"
                    @input="resetFieldErrors('email')"
                  />
                </ValidationProvider>
                <div class="q-gutter-sm">
                  <q-btn
                    label="Envoyer le mail de réinitialisation"
                    :disabled="isSubmit"
                    type="submit"
                    class="text-white bg-grey-9"
                  />
                  <q-btn
                    label="Revenir à la connexion"
                    :disabled="isSubmit"
                    to="/login"
                    color="white"
                    class="q-ml-sm text-grey-9"
                  />
                </div>
              </q-form>
            </ValidationObserver>
          </div>
          <div class="col"></div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { FormMixin } from '~/mixins';
import Header from '~/components/Header';
import { requestResetPassword } from '~/services/user';
import { notifySuccess } from '~/services/notify';

export default {
  mixins: [FormMixin],
  components: {
    Header,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      email: ''
    };
  },
  methods: {
    async processSubmit() {
      const response = await requestResetPassword(
        this.email
      ).then((response) => {
        if (response.status != 200) {
          this.$refs.form.setErrors(response.data.errors);
        } else {
          notifySuccess(response.data.status);
          this.$router.replace(
            {
              name: 'request-reset-password-confirm',
              params: {
                email: this.email,
              },
            },
          );
        }
      });
    }
  }
};
</script>
